import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow } from '@mui/material';
import { Autocomplete, TextField, IconButton } from '@totalsoft/rocket-ui';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const EngineScoringClassificationAttributeListItemComponent = ({
  attribute,
  dispatch,
  isReadOnly,
  validation,
  engineAttributeOptions,
  attributeIndex,
  classificationIndex
}) => {
  const { t } = useTranslation();
  const onPropertyChanged = (property, propertyValue, propertyDescription, propertyDescriptionValue) => {
    dispatch({
      type: 'OnClassificationAttributeChanged',
      property,
      propertyValue,
      propertyDescription,
      propertyDescriptionValue,
      attributeIndex,
      classificationIndex
    });
  };

  const onDeleteAttribute = () => {
    dispatch({
      type: 'OnClassificationAttributeDeleted',
      key: attribute.engineScoringClassificationXEngineAttributeId,
      attributeIndex,
      classificationIndex
    });
  };

  return (
    <TableRow hover>
      <TableCell>
        <TextField
          isNumeric
          fullWidth
          decimalScale={0}
          value={attribute.orderNo}
          disabled={isReadOnly}
          onChange={event => onPropertyChanged('orderNo', event)}
          error={!isValid(validation.orderNo)}
          helperText={getErrors(validation.orderNo)}
        />
      </TableCell>
      <TableCell>
        <Autocomplete
          fullWidth
          labelKey='description'
          valueKey='engineAttributeId'
          value={{ engineAttributeId: attribute.engineAttributeId, description: attribute.description }}
          options={engineAttributeOptions}
          isDisabled={isReadOnly}
          onChange={event =>
            onPropertyChanged(
              'engineAttributeId',
              event !== null ? event.engineAttributeId : null,
              'description',
              event !== null ? event.description : null
            )
          }
          error={!isValid(validation.engineAttributeId)}
          helperText={getErrors(validation.engineAttributeId)}
          isSearchable={true}
        />
      </TableCell>
      <TableCell>
        <IconButton
          type='delete'
          fontSize='medium'
          color='transparent'
          tooltip={t('EngineScoring.EngineClassifications.EngineAttribute.DeleteTooltip')}
          onClick={onDeleteAttribute}
          disabled={isReadOnly}
        />
      </TableCell>
    </TableRow>
  );
};

EngineScoringClassificationAttributeListItemComponent.propTypes = {
  attribute: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  engineAttributeOptions: PropTypes.array.isRequired,
  attributeIndex: PropTypes.number.isRequired,
  classificationIndex: PropTypes.number.isRequired,
  validation: PropTypes.object.isRequired
};

export default EngineScoringClassificationAttributeListItemComponent;
